// working-project.js — WHICH PROJECT THIS BROWSER IS WORKING IN, told to the
// server on every write (INF-8).
//
// Alex, 2026-09-25: internal people "should be able to work on a project as if
// they are a project" — and he chose to decide it by WHERE they are working:
// Standard or a specific project. The top-bar "Working in" selector is
// that choice; App.jsx hands it here, and every same-origin write carries it as
// X-Inoviu-Project. The server's writerOf(req) turns it into the new row's owner;
// ownerOf() in catalog-db.js decides what the signed-in person may claim.
//
// ⚠ ONE PLACE, NOT ONE PER CALL. The owner-taking routes are called from a dozen
// fetch sites across three views, and a header added per call is one that the
// NEXT "+ Add" button forgets — silently, because the row still saves, as
// Standard. Wrapping fetch once means a new write path is covered the day it is
// written. Routes that own nothing simply ignore the header.
//
// ⚠ SAME ORIGIN ONLY. The project id is ours; it has no business in a request to
// Onshape or anywhere else.

const HEADER = 'X-Inoviu-Project';
// D9 (Alex 2026-10-14, "Standard + Own"): READS carry the scope too, under their own
// name, so a listing shows Standard plus the project you are working in ('std' on
// Standard). A separate header because the write header's absence MEANS Standard,
// while a read without a scope must keep meaning "no narrowing" for scripts and old
// tabs. The server only ever narrows with it (catalog-access.js scopedViewer).
const SCOPE_HEADER = 'X-Inoviu-Scope';
const WRITES = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);
let current = '';

// '' (or null) = Standard.
export function setWorkingProject(id) { current = id ? String(id) : ''; }
export function workingProject() { return current; }

function sameOrigin(url, origin) {
  try { return new URL(url, origin).origin === origin; } catch { return false; }
}

export function installWorkingProjectHeader(win = window) {
  if (win.fetch.__workingProject) return;
  const original = win.fetch.bind(win);
  const wrapped = (input, init = {}) => {
    const isRequest = typeof input === 'object' && input !== null && 'url' in input;
    const url = isRequest ? input.url : String(input);
    const method = String(init.method || (isRequest ? input.method : 'GET')).toUpperCase();
    if (!sameOrigin(url, win.location.origin)) return original(input, init);
    const isWrite = WRITES.has(method);
    if (isWrite && !current) return original(input, init);
    const headers = new Headers(init.headers || (isRequest ? input.headers : undefined));
    if (isWrite) headers.set(HEADER, current);
    else headers.set(SCOPE_HEADER, current || 'std');
    return original(input, { ...init, headers });
  };
  wrapped.__workingProject = true;
  win.fetch = wrapped;
}
